import styled from "styled-components";

const WideContent = styled.div`
	width: 93.75%;
	max-width: 1200px;
	margin: 0 auto;
`;

export default WideContent;
